
<template>
    
        <mars-view class="law-content-container"><mars-view v-show="!tabSelectedIdx" class="law-content-box"><mars-scroll-view class="law-scroll-box" scroll-y :scroll-with-animation="isSwan ? true : false" :scroll-top="scrollTop" :scroll-into-view="scrollLawTitleId" @scroll="scroll"><main-content :question-info="questionInfo" :ext-pack="extPack" :issue-time="issueTime" :implement-time="implementTime" :answer="answer" :extra="extra" :content="content" :preamble="preamble" :font-size-setting="fontSizeSetting"></main-content><mars-view v-if="recommendList.length" class="empty"></mars-view><relevant-case v-if="recommendList.length" :recommend-list="recommendList" :import-id="importId" :title="questionInfo.title" :recommend-vip-lawyer-info="recommendVipLawyerInfo" :asp-change-data="aspChangeData" :law-ad-switch="isSwan ? lawAdSwitch : lawAdSwitchH5" :asp-feed-data="aspFeedData" :asp-h5-data="aspH5Data" :ads-h5-change="adsH5Change" :first-reply-is-video="false"></relevant-case><mars-view class="empty"></mars-view><law-guide></law-guide></mars-scroll-view><template><mars-view v-if="nav && nav.length" class="law-fix-btn contents" :class="!questionInfo.jumpUrl ? 'article' : ''" @click.native="showContents"><mars-view class="icon"></mars-view>目录
            </mars-view><mars-view v-if="questionInfo.jumpUrl" class="law-fix-btn article" @click.native="toDetail"><mars-view class="icon"></mars-view>原文
            </mars-view></template></mars-view><mars-view v-show="tabSelectedIdx === 1" class="question-anwser-box"><mars-view class="tab-box"><mars-view v-for="(item, index) in categoryList" :key="index" :class="['tab-item', fieldId === item.value ? 'active' : '']" @click.native="selectQaTab(item)">
                {{ +item.value === 999 ? '推荐问答' : item.text }}
            </mars-view></mars-view><mars-scroll-view class="qa-scroll-box" scroll-y :lower-threshold="200" :scroll-with-animation="isSwan ? true : false" :scroll-top="qaScrollTop" @scrolltolower="fetchMoreQa" @scroll="qaScroll"><mars-view v-if="+fieldId === 999" class="qa-list-box"><relevant-case-question v-if="aspQuestionFeedData.length || (aspQuestionH5Data && aspQuestionFeedH5Data)" :recommend-list="recommendQuestionList" :import-id="importId" :title="questionInfo.title" :asp-feed-data="aspQuestionFeedData" :asp-h5-data="aspQuestionH5Data" :asp-h5-feed-data="aspQuestionFeedH5Data" :first-reply-is-video="false" module-from="law-question"></relevant-case-question></mars-view><mars-view v-else class="qa-list-box"><mars-view v-for="(qaItem,index) in qaList" :key="index" class="qa-item-box"><answer-item :answer-info="qaItem"></answer-item></mars-view></mars-view></mars-scroll-view></mars-view><ui-directory v-show="isShowContents" :menus="nav" @changeContentsStatus="changeContentsStatus" @jumpContent="jumpContent" @closeContents="hideContents"></ui-directory></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */
import { formatTimeToDate, handleKeyWord } from '../../../pages/qalandpage/utils/util.js';
import { request, getData } from '../../../static/utils/request';
import mainContent from "./main-content.vue";
import relevantCase from "./relevant-case.vue";
import relevantCaseQuestion from "./relevant-case-question.vue";
import answerItem from "./answer-item.vue";
import directory from "./directory.vue";
import lawGuide from "./law-guide.vue";
import { act } from '../../../static/utils/navigate';
import { reqPathTo } from '../../../static/utils/env';
import log from '../../../static/utils/ubcLog';
import Observer from '../../../common/js/observer.js';
export default {
  components: {
    'main-content': mainContent,
    'relevant-case': relevantCase,
    'relevant-case-question': relevantCaseQuestion,
    'answer-item': answerItem,
    'ui-directory': directory,
    'law-guide': lawGuide
  },
  props: {
    // 问题相关数据
    questionInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // 答主信息
    answer: {
      type: Object,
      default() {
        return {};
      }
    },
    // 当前菜单
    curTab: {
      type: Number,
      default: 0
    },
    // 实验id
    adsEid: {
      type: Number,
      default: 0
    },
    // 标识问题来源
    importId: {
      type: Number,
      default: 0
    },
    lawAdSwitch: {
      type: Object,
      default() {
        return {};
      }
    },
    // 1059广告
    aspChangeData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 广告
    aspFeedData: {
      type: Array,
      default() {
        return [];
      }
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'curTab': {
      immediate: true,
      handler(val) {
        if (val !== undefined && this.tabSelectedIdx !== val) {
          this.tabSelectedIdx = val;
          this.isScrollToBottom = false;
          // 问答tab
          if (+val === 1 && !this.isFirstQaTabClick) {
            this.isFirstQaTabClick = true;
            this.getQaData();
          }
        }
      }
    }
  },
  computed: {
    // ext信息
    extPack() {
      let {
        ext_pack = {}
      } = this.questionInfo || {};
      return ext_pack;
    },
    // 发布时间
    issueTime() {
      let {
        issue_time
      } = this.extPack;
      if (!issue_time) {
        return '';
      }
      return formatTimeToDate(issue_time);
    },
    // 生效时间
    implementTime() {
      let {
        implement_time
      } = this.extPack;
      if (!implement_time) {
        return '';
      }
      return formatTimeToDate(implement_time);
    }
  },
  data() {
    return {
      // tab idx
      tabSelectedIdx: 0,
      // 目录
      nav: [],
      // 导航栏顶部高度
      totalTitleHeight: 58,
      // 目录跳转选择的id
      scrollLawTitleId: undefined,
      // 法律正文内容
      content: [],
      // 实际展示的法律正文内容
      showContent: [],
      // 法律修订内容
      extra: '',
      // 实际展示法律修订内容
      showExtra: '',
      // 检索数量
      searchNum: 0,
      // 检索内容
      searchContent: '',
      // 是否展示目录
      isShowContents: false,
      // 是否展示检索输入框
      isShowSearchInput: false,
      // 页面滚动方向
      pageScrollDirection: '',
      // 页面停止滚动定时器
      pageScrollTimer: null,
      // 问答tab列表
      categoryList: [],
      // 问答列表-领域id
      fieldId: 999,
      // 问答列表
      qaList: [],
      // 问答数据-页数
      qaPn: 0,
      // 问答数据-拉取条数
      qaRn: 10,
      // 请求锁
      requestLock: false,
      // 问答列表滚动
      qaScrollTop: 0,
      // 用于展示的相关推荐
      recommendList: [],
      // 法律问答tab下推荐问答的列表
      recommendQuestionList: [],
      isFirstQaTabClick: false,
      contentHeight: 0,
      recommendVipLawyerInfo: {},
      lawAdSwitchH5: {},
      aspH5Data: null,
      adsH5Change: null,
      isSwan: "h5" === 'swan',
      isScrollToBottom: false,
      mainContentScrollTop: 0,
      contentScrollTop: 0,
      scrollTop: 0,
      qaContentScrollTop: 0,
      preamble: '',
      // 问答tab下的广告数据
      aspQuestionFeedData: [],
      // 问答tab下h5的前三条广告数据
      aspQuestionFeedH5Data: null,
      aspQuestionH5Data: null
    };
  },
  created() {
    this.getLawContent(this.questionInfo.contentUrl);
    // 相关推荐数据
    this.getSimilarCase();
    this.onPageShow = this.onPageShow.bind(this);
    this.onPageHide = this.onPageHide.bind(this);
    Observer.addObserver('onPageShow', this.onPageShow);
    Observer.addObserver('onPageHide', this.onPageHide);
  },
  mounted() {
    {
      let rids = [];
      let answerList = [];
      if (this.dataNewbest) {
        let newbest = this.dataNewbest;
        if (newbest && newbest[0]) {
          rids.push(newbest[0].rid);
          answerList.push(newbest[0].contentText.slice(0, 50).replace(/[\r\n]/g, ''));
        }
      }
      if (this.dataReplies) {
        let replies = this.dataReplies;
        replies && Object.keys(replies).forEach(function (idx) {
          if (rids.length < 3) {
            rids.push(replies[idx].rid);
            answerList.push(replies[idx].contentText.slice(0, 50).replace(/[\r\n]/g, ''));
          }
        });
      }
      const question = this.questionInfo || {};
      request({
        url: reqPathTo('getqbcontent', {}, '', 'lawqb'),
        data: {
          qid: question.qid,
          title: question.title,
          hitEid: this.adsEid,
          samphit: question.samphit,
          rid: rids[0] || '',
          rids,
          sfrom: 'lvlin'
        },
        loginNeeded: false,
        needBduss: true
      }).then(res => {
        const data = res && res.data && res.data.data && res.data.data.adsAll || {};
        this.lawAdSwitchH5 = res && res.data && res.data.data && res.data.data.lawAdSwitch || {};
        this.aspH5Data = Array.isArray(data.ads) ? null : data.ads;
        if (this.aspH5Data) {
          this.aspH5Data.placeDataIsArray = this.aspH5Data.wapqbmarketing && this.aspH5Data.wapqbmarketing.ad_place_data && Array.isArray(this.aspH5Data.wapqbmarketing.ad_place_data);
        }
        this.adsH5Change = Array.isArray(data.adsChange) ? null : data.adsChange;
        const aspH5DataNum = this.aspH5Data && this.aspH5Data.wapqbmarketing && this.aspH5Data.wapqbmarketing.ad_num || 0;
        const adsH5ChangeNum = this.adsH5Change && this.adsH5Change.wapyouxchangeasp && this.adsH5Change.wapyouxchangeasp.ad_num || 0;
        aspH5DataNum + adsH5ChangeNum && log.send && log.send({
          serverId: 16206,
          area: 'zijianye_gg_show',
          action: 'show',
          cm_num: `1929_${aspH5DataNum},1930_${adsH5ChangeNum}`
        });
      });
    }
  },
  beforeDestroy() {
    Observer.removeObserver('onPageShow', this.onPageShow);
    Observer.removeObserver('onPageHide', this.onPageHide);
  },
  methods: {
    // 获取法律主体内容
    getLawContent(url) {
      request({
        url
      }).then(res => {
        let {
          nav = [],
          content = [],
          extra = '',
          preamble = ''
        } = res.data;
        // 序言-目录中增加序言模块
        if (preamble) {
          nav.unshift({
            children: [],
            index: 'section_1_0_0',
            text: '序言',
            type: 'section_1'
          });
        }
        this.nav = nav;
        preamble = preamble && preamble.replace(/(<br>|<br\/>|<br \/>)/g, '<br /><div class="clause"></div>') || '';
        this.preamble = preamble;
        this.content = this.contentHandler(content);
        this.showContent = content;
        this.extra = extra || '';
        this.showExtra = extra || '';
        this.$nextTick(() => {
          // 正文数据渲染完整，结构化法律QB页跳转过来，延迟1000毫秒，模糊定位
          setTimeout(() => {
            this.lawStructLocation();
          }, 1000);
        });
      }).catch(() => {});
    },
    /**
     * 内容处理
     * @param {ayyay} content 内容列表
     */
    contentHandler(content) {
      if (!content || !(content instanceof Array)) {
        return [];
      }
      let tempList = [...content];
      const urlInfo = this.getUrlInfo();
      const {
        searchWord = ''
      } = urlInfo || {};
      const queryWord = decodeURIComponent(searchWord);
      tempList.forEach(item => {
        if (item.text) {
          item.text = item.text.replace(/(<br>|<br\/>|<br \/>)/g, '<br />').replace(/(<br \/><br \/>|<br \/><br \/><br \/>)/g, '<br /><div class="clause"></div>');
          if (item.text.indexOf(queryWord) > -1 && queryWord) {
            item.text = item.text.replaceAll(queryWord, `<span style="color: #eb3333;">${queryWord}</span>`);
          }
        }
      });
      return tempList;
    },
    getUrlInfo() {
      let urlInfo = {};
      urlInfo = this.getH5UrlParamObj();
      return urlInfo;
    },
    // 结构化法律QB页跳转过来，模糊定位
    lawStructLocation() {
      const {
        content
      } = this;
      const urlInfo = this.getUrlInfo();
      const {
        keyword = ''
      } = urlInfo || {};
      const word = decodeURIComponent(keyword);
      const lawResult = content.find(item => item.text.includes(word));
      this.scrollLawTitleId = lawResult && lawResult.index !== undefined ? lawResult.index : '';
    },
    /**
     * 获取h5-URL参数
    */
    getH5UrlParamObj() {
      let obj = {};
      // 获取url的参数部分
      let params = window.location.search.substr(1);
      // [^&=]+ 表示不含&或=的连续字符，加上()就是提取对应字符串
      params.replace(/([^&=]+)=([^&=]*)/gi, function (rs, $1, $2) {
        obj[$1] = decodeURIComponent($2);
      });
      return obj;
    },
    onPageShow() {
      this.$nextTick(() => {
        if (+this.curTab === 0) {
          this.scrollTop = this.mainContentScrollTop;
        } else if (+this.curTab === 1) {
          this.qaScrollTop = this.mainContentScrollTop;
        }
      });
    },
    onPageHide() {
      if (+this.curTab === 0) {
        this.mainContentScrollTop = this.contentScrollTop;
      } else if (+this.curTab === 1) {
        this.mainContentScrollTop = this.qaContentScrollTop;
      }
    },
    /**
     * 新版-获取问答列表
     */
    getQaData() {
      if (+this.fieldId === 999 || !this.fieldId) {
        if (this.recommendQuestionList.length) {
          return;
        }
        this.getRecommendQuestion();
      }
      const data = {
        // 排序类型，1智能排序，2热门排序，3最新排序
        sortType: 1,
        // 领域菜单-对应value,默认全部领域 999
        tabId: this.fieldId
      };
      const getFristDataUrl = reqPathTo('special_qa_page', {}, '', 'falv');
      getData({
        url: getFristDataUrl,
        data,
        loginNeeded: false
      }).then((data = {}) => {
        let {
          qaList = [],
          tags = []
        } = data;
        // 领域信息
        if (!this.categoryList.length) {
          this.categoryList = tags;
        }
        this.qaList = qaList;
        // 分页数重置为第一页
        this.qaPn = 1;
        this.$nextTick(() => {
          setTimeout(() => {
            this.qaScrollTop = 0;
          }, 0);
        });
      }).catch(() => {});
    },
    getRecommendQuestion() {
      request({
        url: reqPathTo('questionrecommend', {}, '', 'swan/ajax'),
        data: {
          'recommend_type': 'law',
          sfrom: 'lvlin',
          qid: this.questionInfo && this.questionInfo.qid,
          subRecType: 'law_regulation'
        }
      }).then(res => {
        if (!res.data || res.data.errNo !== 0) {
          return;
        }
        let {
          recommendContent = []
        } = res.data || {};
        recommendContent.forEach((item, index) => {
          if (item && item.ask) {
            let titleHighlight = item.ask.title_highlight || [];
            let abstractHighlight = item.ask.abstract_highlight || [];
            recommendContent[index].richTitle = titleHighlight.length > 0 ? handleKeyWord(item.ask.title, titleHighlight) : '';
            recommendContent[index].richContent = abstractHighlight.length > 0 ? handleKeyWord(item.ask.replieData && item.ask.replieData.contentText, abstractHighlight) : '';
          }
        });
        this.recommendQuestionList = recommendContent;
      }).catch(() => {});
      this.getAdData();
    },
    getAdData() {
      request({
        url: reqPathTo('getqbcontent', {}, '', 'lawqb'),
        data: {
          qid: this.questionInfo && this.questionInfo.qid,
          sfrom: 'lvlin'
        },
        loginNeeded: false,
        needBduss: true
      }).then(res => {
        const data = res && res.data && res.data.data && res.data.data.adsAll || {};
        let aspFeedData = {};
        let aspData = {};
        if (data.ads) {
          aspData = data.ads;
        }
        if (data.adsChange) {
          aspFeedData = data.adsChange;
        }
        this.aspQuestionFeedH5Data = aspFeedData;
        this.aspQuestionH5Data = aspData;
      }).catch(() => {});
    },
    /**
     * 问答列表-加载更多
     */

    getMoreQaList() {
      if (this.requestLock) {
        return;
      }
      this.requestLock = true;
      const url = reqPathTo('special_qa_list', {}, '', 'falv');
      const params = {
        sortType: 1,
        pn: this.qaPn,
        rn: this.qaRn,
        tabId: this.fieldId
      };
      getData({
        url,
        data: params
      }).then(res => {
        this.requestLock = false;
        let list = res.qaList || [];
        let hasMore = res.has_more;
        // 存在数据过滤的问题，不能使用length来判断
        if (!hasMore) {
          this.noMoreResult = this.qaPn !== 1;
        } else {
          this.qaPn += 1;
        }
        this.qaList = [...this.qaList, ...list];
      }).catch(() => {
        this.requestLock = false;
      });
    },
    // 问答列表下拉加载更多
    fetchMoreQa() {
      if (this.noMoreResult) {
        return;
      }
      this.getMoreQaList();
    },
    /**
     * 问答列表-滚动
     */
    qaScroll(e) {
      const curTop = e && e.detail && e.detail.scrollTop;
      this.qaContentScrollTop = curTop;
      let flag = curTop > 100;
      if (this.isScrollToBottom === flag) {
        return;
      }
      this.isScrollToBottom = flag;
      this.$emit('updateScrollToBottom', flag);
    },
    /**
     * 获取相关案例数据
     */
    getSimilarCase() {
      request({
        url: reqPathTo('questionrecommend', {}, '', 'swan/ajax'),
        data: {
          'recommend_type': 'law',
          sfrom: 'lvlin',
          qid: this.questionInfo && this.questionInfo.qid,
          subRecType: 'law_regulation'
        }
      }).then(res => {
        if (!res.data || res.data.errNo !== 0) {
          return;
        }
        let {
          recommendContent = [],
          recommendVipLawyerInfo = {}
        } = res.data || {};
        recommendContent.forEach((item, index) => {
          if (item && item.ask) {
            let titleHighlight = item.ask.title_highlight || [];
            let abstractHighlight = item.ask.abstract_highlight || [];
            recommendContent[index].richTitle = titleHighlight.length > 0 ? handleKeyWord(item.ask.title, titleHighlight) : '';
            recommendContent[index].richContent = abstractHighlight.length > 0 ? handleKeyWord(item.ask.replieData && item.ask.replieData.contentText, abstractHighlight) : '';
          }
        });
        this.recommendList = recommendContent;
        this.recommendVipLawyerInfo = recommendVipLawyerInfo;
      }).catch(() => {});
    },
    // 获取3个随机律师展示
    getRandomLawyer(recommendLawyer) {
      const showLawyer = [];
      while (showLawyer.length < 3) {
        const range = recommendLawyer.length - 1;
        const randomLawyerIndex = Math.round(Math.random() * range);
        const lawyer = recommendLawyer[randomLawyerIndex];
        lawyer.tagsStr = lawyer.lawDomain.join('、');
        showLawyer.push(lawyer);
      }
      return showLawyer;
    },
    // 问答tab切换
    selectQaTab(item) {
      let {
        value
      } = item;
      if (this.fieldId === value) {
        return;
      }
      this.fieldId = value;
      this.requestLock = false;
      this.qaPn = 1;
      this.qaScrollTop = 0;
      this.qaList = [];
      this.getQaData();
    },
    // 展示目录
    showContents() {
      this.isShowContents = true;
    },
    // 隐藏目录
    hideContents() {
      this.isShowContents = false;
    },
    // 展示检索输入框
    showSearchInput() {
      this.isShowSearchInput = true;
    },
    // 隐藏检索输入框
    hideSearchInput() {
      this.isShowSearchInput = false;
    },
    /**
     * 跳转至指定id的标题且关闭目录弹窗
     * @param {object} info
     */
    jumpContent(info) {
      let {
        jumpId
      } = info || {};
      if (!jumpId) {
        return;
      }
      this.scrollLawTitleId = jumpId;
      this.hideContents();
    },
    /**
     * 点击目录切换子目录展示/隐藏
     * @param {object} params 参数
     * @param {number} params.firstIdx 一级节点下标
     * @param {number} params.secondIdx 二级节点下标
     */
    changeContentsStatus(params) {
      const {
        firstIdx = '',
        secondIdx = ''
      } = params || {};
      let nav = [...this.nav];
      if (firstIdx === '') {
        return;
      }
      try {
        if (secondIdx !== undefined && secondIdx !== '') {
          nav[firstIdx].children[secondIdx].isShowChildren = !nav[firstIdx].children[secondIdx].isShowChildren;
        } else {
          nav[firstIdx].isShowChildren = !nav[firstIdx].isShowChildren;
        }
      } catch (err) {}
      this.nav = nav;
    },
    // 跳转详细信息页面
    toDetail() {
      if (!this.questionInfo.jumpUrl) {
        return;
      }
      log.send && log.send({
        serverId: 17017,
        area: 'bdfb-yuanwen',
        action: 'click'
      });
      act({
        target: this.questionInfo.jumpUrl,
        type: 'webview'
      });
    },
    // 监听页面滚动
    scroll(e) {
      const curTop = e && e.detail && e.detail.scrollTop;
      let flag = curTop > 100;
      this.contentScrollTop = curTop;
      if (this.isScrollToBottom !== flag) {
        this.isScrollToBottom = flag;
        this.$emit('updateScrollToBottom', flag);
      }
    }
  }
};
</script>

<style scoped>
.law-content-container {
  position: relative;
  height: 100%;
}
.law-content-container .law-content-box,
.law-content-container .question-anwser-box {
  height: 100%;
}
.law-content-container .law-scroll-box {
  height: 100%;
}
.law-content-container .law-scroll-box .empty {
  width: 100%;
  height: 1.93vw;
  background: #f5f6f9;
}
.law-content-container .question-anwser-box {
  display: flex;
  flex-direction: column;
  padding: 3.14vw 4.11vw 0;
}
.law-content-container .question-anwser-box .tab-box {
  display: flex;
  align-items: center;
  overflow-x: auto;
  padding-bottom: 1.93vw;
}
.law-content-container .question-anwser-box .tab-box::-webkit-scrollbar {
  display: none;
}
.law-content-container .question-anwser-box .tab-box .tab-item {
  height: 7.97vw;
  padding: 0 3.14vw;
  background: #f5f6f9;
  border-radius: 2.17vw;
  font-family: PingFang SC;
  font-size: 3.38vw;
  color: #1e1f24;
  text-align: center;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.law-content-container .question-anwser-box .tab-box .tab-item:not(:first-child) {
  margin-left: 2.01vw;
}
.law-content-container .question-anwser-box .tab-box .tab-item.active {
  font-family: PingFang SC;
  font-weight: 700;
  color: #0355ff;
}
.law-content-container .question-anwser-box .qa-scroll-box {
  height: 0;
  flex: 1;
}
.law-content-container .question-anwser-box .qa-list-box {
  margin-top: -1.93vw;
}
.law-content-container .law-fix-btn {
  position: fixed;
  z-index: 9;
  width: 11.59vw;
  height: 11.59vw;
  right: 4.11vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border: 1px solid rgba(47, 50, 62, 0.05);
  box-shadow: 0 0.81vw 1.45vw 0 rgba(47, 50, 62, 0.12);
  border-radius: 5.8vw;
  font-family: PingFang SC;
  font-size: 2.42vw;
  color: #50525c;
  line-height: 2.42vw;
}
.law-content-container .law-fix-btn .icon {
  margin-bottom: 0.725vw;
  width: 4.59vw;
  height: 4.59vw;
  background-size: 100% 100%;
}
.law-content-container .law-fix-btn.contents {
  bottom: 45.81vw;
}
.law-content-container .law-fix-btn.contents .icon {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/contents.png');
}
.law-content-container .law-fix-btn.article {
  bottom: 30.84vw;
}
.law-content-container .law-fix-btn.article .icon {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/origin-article.png');
}

</style>
